import { MathText } from "@/components/MathText";

const Diagram = ({ svg }) => (
  <figure className="my-4 flex justify-center" data-testid="question-diagram">
    <div
      className="w-full max-w-[320px] rounded-xl border border-border bg-secondary/30 p-4 text-foreground [&_svg]:h-auto [&_svg]:w-full"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  </figure>
);

/** Renders a question's text (LaTeX) and its optional textbook-style SVG diagram. */
export const QuestionContent = ({ question, className = "", "data-testid": testId }) => (
  <div data-testid={testId}>
    <MathText block className={className} text={question.questionText} />
    {question.diagram ? <Diagram svg={question.diagram} /> : null}
  </div>
);
